export default __webpack_public_path__ + "static/SSSpyView_screenshot-4@mob2x-273c106a653b2614fee1ad748f634d63.jpg";